import { render } from "./ZoneWizardPhysicalNetworkSetupStep.vue?vue&type=template&id=797b9921&scoped=true"
import script from "./ZoneWizardPhysicalNetworkSetupStep.vue?vue&type=script&lang=js"
export * from "./ZoneWizardPhysicalNetworkSetupStep.vue?vue&type=script&lang=js"

import "./ZoneWizardPhysicalNetworkSetupStep.vue?vue&type=style&index=0&id=797b9921&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-797b9921"]])

export default __exports__